<template>
   <div id="storeManagement">
      <Loading v-if="loading"/>
      <div class="container-fluid">
         <div class="row justify-content-between align-items-center">
            <div class="col-auto back-button">
               <i class="fal fa-chevron-left step-button p-2" @click="backDashboad"></i>
            </div>
            <!--<div class="col-auto save-butom">
               <span @click="savePage">Salvar</span>
            </div>-->
         </div>
      </div>
      <div class="container pt-3">
         <div class="row text-left">
            
            <div class="col-12">
               <h3>Gerenciar loja</h3>
            </div>
            

            
         </div>
      </div>
   </div>
</template>

<script>
import axios from 'axios';
import Loading from '@/components/Loading.vue';
export default {
   name: 'storeManagement',
   data(){
      return{
         loading: true,
         totalPage: {},
         ROOT_API: '',
         errorList: [],
         saveError: false
      }
   },
   components:{
      Loading
   },
   created(){
      this.ROOT_API = process.env.ROOT_API;
      var siteId = this.$session.get("siteId");

      axios({
            method: 'get',
            url: `${this.ROOT_API}/api/store/login?site=${siteId}`,
            headers: {
                'Authorization': 'Bearer ' + this.$session.get('jwt'),
                // 'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
        .then(response => {
            if( response.data.status == 1 && response.data.url ){
               var store = response.data.url;

               window.location = response.data.url;
               
               // var a = document.createElement('a');
               // a.target="_blank";
               // a.href='http://' + window.location.hostname + '/dashboard';
               // a.click();   
            	// window.location = store;

               // var redirectWindow = window.open(response.data.url, '_blank');
               // redirectWindow.location;
            }
            else{
            	window.location = '/dashboard';
            }
        })
        .catch(error => {
            window.location = '/dashboard';
        })
   },
   mounted(){
      //this.getPageData();
   },
   methods:{
        backDashboad(){
            window.localStorage.removeItem('pageId');
            this.$router.push('/dashboard');
        }
   }
}
</script>

<style scoped>
   .back-button, .save-butom span{
      color: var(--main-color);
      cursor: pointer;
   }
   label{
      font-size: 0.8rem;
      margin-bottom: 0;
      color: #333333
   }
   .error-list{
      color: #d61a1a;
   }
   .error-list ul{
      padding: 0 15px;
   }
   .error-list ul li{
      font-size: 0.8rem;
   }
</style>


// WEBPACK FOOTER //
// src/components/organisms/StoreManagement.vue